import Immutable from 'immutable';
import { createSelector } from 'reselect';
import { selectLikeEntities } from '../EntitiesSelector';
import { selectCurrentUser } from '../AuthSelector';

export const selectCurrentUserLikes = createSelector([selectLikeEntities, selectCurrentUser], (likes, currentUser) => {
  const currentUserLikes = likes.filter(like => like && like.get('ownerId') === currentUser.get('id'));
  // Roughly equivalent to keyBy(currentUserLikes, 'id')
  return Immutable.Map(currentUserLikes.toList().map(v => [v.get('contentId'), v]));
});
